export interface AddressComponents {
  street?: string;
  streetNumber?: string;
  apartmentNumber?: string;
  postalCode?: string;
  town?: string;
}

export const formatAddress = (components: AddressComponents): string => {
  const parts: string[] = [];

  if (components.street || components.streetNumber) {
    const streetPart = [
      components.street,
      components.streetNumber,
      components.apartmentNumber ? `/${components.apartmentNumber}` : ''
    ].filter(Boolean).join(' ');
    
    if (streetPart) {
      parts.push(streetPart);
    }
  }

  if (components.postalCode || components.town) {
    const cityPart = [components.postalCode, components.town]
      .filter(Boolean)
      .join(' ');
    
    if (cityPart) {
      parts.push(cityPart);
    }
  }

  return parts.join(', ');
};

export const formatCoordinates = (latitude?: number | null, longitude?: number | null): string => {
  if (latitude == null || longitude == null) {
    return '';
  }
  return `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`;
};

